import { Labels } from '../../shared-components/global/labels.js';

Labels.set('ui-phonefield', 'INVALID', 'Номер телефона введен неверно.');
Labels.set('ui-phonefield', 'CHOOSE_COUNTRY', 'Выбериет стрену');
Labels.set('ui-phonefield', 'PHONENR', 'Номер телефона');
